import { useLocation } from 'react-router-dom';

import { useEffect } from 'react';

/**
 * Scrolls to the top of the page when the route changes.
 * This ensures users always start at the top when navigating to a new page.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
